import { AIConfigsContext } from "@/context/AIConfigsContext";
import React from "react";

export default function useAIConfigs() {
  return React.useContext(AIConfigsContext);
}
